module.exports = __webpack_public_path__ + "57e078834480bb1449c91d2e0edb71f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 85
// module chunks = 1